import request from "@/utils/request.js";

// 修改用户密码
export const editPassword = (updateData) => {
    return request.put(`/admin/password?password=${updateData.password}`)
}
